"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackAGBConsent = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackAGBConsent(hasTermsDocuments, hasTravelDocuments) {
    const AGBsToTrack = ['display_generalCheckbox'];
    const termsPartners = 'termsPartners';
    const termsTravel = 'termsTravel';
    if (hasTermsDocuments && hasTravelDocuments) {
        AGBsToTrack.push(termsPartners, termsTravel);
    }
    else if (hasTermsDocuments) {
        AGBsToTrack.push(termsPartners);
    }
    else if (hasTravelDocuments) {
        AGBsToTrack.push(termsTravel);
    }
    (0, pushToDataLayer_1.pushToDataLayer)({
        AGBtype: AGBsToTrack.join('_'),
    });
}
exports.trackAGBConsent = trackAGBConsent;
//# sourceMappingURL=trackAGBConsent.js.map